import React from "react";
import topImage from "../assets/top.png";

import { useNavigate } from "react-router-dom";
import "../styles/SuccessPage.css";
const SuccessPage = () => {
  const navigate = useNavigate();

  return (
    <>
      
      <div className="success-container">
        
        <div className="success-card">
          <img src={topImage} alt="Top Banner" />
          <h1>Navig8 Vision Directory Day 2</h1>
          <p>
            Directory details submitted successfully.
          </p>
          <button onClick={() => navigate("/")}>Submit Another Response</button>
        </div>
      </div>
    </>
  );
};

export default SuccessPage;
